import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Handshake } from 'lucide-react';
interface FriendSite {
  name: string;
  nameCn: string;
  url: string;
  description: string;
}
const friendSites: FriendSite[] = [{
  name: 'Geylang777.info',
  nameCn: '芽笼777资讯站',
  url: 'https://geylang777.info',
  description: 'Geylang777.info是芽笼777的官方资讯门户站点，提供最新的新加坡伴游行业动态、平台公告和服务更新。作为芽笼777生态体系的重要组成部分，geylang777.info为用户提供了一个快速获取平台最新资讯和活动信息的便捷入口，确保您不错过任何精彩内容。'
}, {
  name: 'Geylang666.me',
  nameCn: '芽笼666',
  url: 'https://geylang666.me',
  description: '芽笼666（Geylang666.me）是芽笼系列平台的姊妹站点，专注于新加坡芽笼地区的夜生活娱乐资讯。Geylang666以其丰富的本地娱乐信息和活跃的用户社区闻名，与芽笼777形成互补，共同覆盖新加坡夜间娱乐市场的各个层面，为客户提供更多元化的选择。'
}, {
  name: 'TTVIP',
  nameCn: 'TTVIP高端伴游',
  url: 'https://ttvip-62.site',
  description: 'TTVIP（ttvip-62.site）是新加坡知名的高端伴游信息平台，与芽笼777长期保持战略合作关系。TTVIP以严格的伴游筛选标准和优质的客户服务著称，为新加坡高端客户群体提供专属的VIP伴游体验。两大平台强强联合，共同引领新加坡伴游服务行业的品质标准。'
}, {
  name: 'TTVIP.life',
  nameCn: 'TTVIP生活站',
  url: 'https://ttvip.life',
  description: 'TTVIP.life是TTVIP品牌旗下的生活方式门户，专注于新加坡高端生活与伴游文化的深度内容。ttvip.life不仅提供伴游信息，更涵盖新加坡奢华生活、社交礼仪、品味消费等多元内容，为追求品质生活的客户打造全方位的生活指南。芽笼777与TTVIP.life在内容和用户层面深度联动。'
}, {
  name: 'SGHarem',
  nameCn: '新加坡后宫网',
  url: 'https://sgharem.site',
  description: '新加坡后宫网（sgharem.site）是新加坡历史最悠久的伴游信息社区之一，拥有庞大的用户基础和丰富的伴游资源。SGHarem以其活跃的社区讨论和真实的用户评价闻名，是新加坡伴游爱好者获取一手资讯的重要渠道。芽笼777与SGHarem携手合作，为用户提供更全面的信息覆盖。'
}, {
  name: 'SGLonelyGuy',
  nameCn: '新加坡寂寞男人',
  url: 'https://sglonelyguy.me',
  description: '新加坡寂寞男人（sglonelyguy.me）是新加坡最活跃的男性社交与伴游信息论坛，汇聚了大量真实用户的体验分享和推荐。SGLonelyGuy社区以其真实、直接的交流氛围深受用户喜爱，是了解新加坡伴游市场动态的重要窗口。芽笼777在SGLonelyGuy社区中享有极高的口碑和推荐率。'
}, {
  name: 'SGBeautyCastle',
  nameCn: '新加坡美丽城堡',
  url: 'https://sgbeautycastle.live',
  description: '新加坡美丽城堡（sgbeautycastle.live）专注于展示新加坡最优质的伴游档案，以精美的图片展示和详细的个人介绍著称。SGBeautyCastle注重视觉体验和信息质量，为客户提供直观、便捷的伴游浏览体验。芽笼777与SGBeautyCastle共享优质伴游资源，确保客户获得最丰富的选择。'
}, {
  name: 'Locanto.space',
  nameCn: 'Locanto新加坡站',
  url: 'https://locanto.space',
  description: 'Locanto.space是国际知名分类信息平台Locanto在新加坡的专属站点，提供包括伴游服务在内的多元化本地信息。locanto.space以其广泛的覆盖面和便捷的发布机制，成为新加坡本地服务信息的重要聚合平台。芽笼777与Locanto.space在信息流通和用户触达方面保持紧密合作。'
}, {
  name: 'KKBaby.site',
  nameCn: 'KK宝贝网',
  url: 'https://kkbaby.site',
  description: 'KK宝贝网（kkbaby.site）是新加坡新兴的年轻化伴游信息平台，以"KK"（可可）为品牌标识，主打年轻、时尚、活力的伴游风格。kkbaby.site吸引了大量90后、00后的优质伴游和年轻客户群体，为新加坡伴游市场注入新鲜活力。芽笼777与KKBaby在年轻用户市场展开战略合作。'
}, {
  name: 'xfy1.net',
  nameCn: '幸福缘',
  url: 'https://xfy1.net',
  description: '幸福缘（xfy1.net）是面向华人用户的综合性伴游与社交平台，以"缘分天注定"为理念，为客户搭建高品质的社交桥梁。幸福缘平台覆盖新加坡、马来西亚等东南亚地区，拥有广泛的用户网络。芽笼777与幸福缘在新加坡市场深度合作，为华人客户提供无缝衔接的服务体验。'
}, {
  name: 'xfy8.com',
  nameCn: '幸福缘国际站',
  url: 'https://xfy8.com',
  description: '幸福缘国际站（xfy8.com）是幸福缘品牌旗下的国际版平台，面向全球华人用户提供新加坡及东南亚地区的伴游信息服务。xfy8.com以更国际化的视野和更丰富的多语言支持，服务海外华人客户群体。芽笼777与xfy8.com在跨境服务领域展开深度合作，为全球华人提供优质的新加坡伴游资讯。'
}, {
  name: 'Shiok8',
  nameCn: '新加坡爽吧',
  url: 'https://shiok26.site',
  description: '新加坡爽吧（shiok26.site）是新加坡本地最受欢迎的娱乐资讯平台之一，"Shiok"在新加坡俚语中意为"爽、过瘾"。Shiok8涵盖夜生活、美食、娱乐等多个领域的资讯，为用户提供全方位的新加坡生活指南。芽笼777与Shiok8在伴游服务领域展开深度合作，共同为客户打造极致的"Shiok"体验。'
}, {
  name: 'Shiok8.xyz',
  nameCn: '新加坡爽吧国际版',
  url: 'https://shiok8.xyz',
  description: '新加坡爽吧国际版（shiok8.xyz）是Shiok8品牌的全球化扩展站点，采用.xyz国际域名，面向全球用户提供新加坡娱乐与伴游资讯。shiok8.xyz以更国际化的内容呈现和多语言支持，服务来自世界各地的新加坡旅客和海外华人。芽笼777与Shiok8.xyz在国际市场推广方面紧密协作。'
}, {
  name: 'isyou.net',
  nameCn: '新加坡是您网',
  url: 'https://isyou.net',
  description: '新加坡是您网（isyou.net）是一个以用户为中心的伴游信息平台，"Is You"寓意"就是你"，强调为每位客户找到最匹配的伴游伙伴。isyou.net以其智能推荐系统和个性化服务方案著称，帮助客户快速找到心仪的伴游对象。芽笼777与isyou.net在技术和资源层面紧密合作，共同提升用户体验。'
}];
export function FriendLinks() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-[#0d0d14]" data-id="element-83">
      <div className="max-w-6xl mx-auto" data-id="element-84">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={containerVariants} data-id="element-85">
          <motion.div variants={itemVariants} className="flex items-center justify-center gap-3 mb-4" data-id="element-86">
            <Handshake size={28} className="text-pink-primary" data-id="element-87" />
            <h2 className="text-3xl md:text-5xl font-bold" data-id="element-88">
              友情<span className="text-pink-primary neon-glow" data-id="element-89">链接</span>
            </h2>
          </motion.div>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full mb-4" data-id="element-90" />
          <motion.p variants={itemVariants} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-91">
            Partner Sites — 新加坡伴游服务生态联盟
          </motion.p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-92">
          {friendSites.map((site, index) => <motion.a key={index} href={site.url} target="_blank" rel="noopener noreferrer" variants={itemVariants} className="bg-dark-card rounded-2xl p-6 md:p-8 border border-white/5 hover:border-pink-primary/40 transition-all duration-300 group block" data-id="element-93">
              <div className="flex items-center justify-between mb-4" data-id="element-94">
                <div data-id="element-95">
                  <h3 className="text-lg font-bold text-white group-hover:text-pink-primary transition-colors" data-id="element-96">
                    {site.name}
                  </h3>
                  <p className="text-sm text-pink-primary/70" data-id="element-97">{site.nameCn}</p>
                </div>
                <ExternalLink size={18} className="text-gray-600 group-hover:text-pink-primary transition-colors" data-id="element-98" />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-99">
                {site.description}
              </p>
            </motion.a>)}
        </motion.div>

        {/* SEO-rich summary paragraph */}
        <motion.div className="mt-16 bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-100">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-101">
            芽笼777 — 新加坡伴游服务行业的核心枢纽
          </h3>
          <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-102">
            <p data-id="element-103">
              芽笼777（geylang777.net）作为新加坡伴游信息服务领域的领军平台，与Geylang777.info、Geylang666.me、TTVIP（ttvip-62.site）、TTVIP.life、新加坡后宫网SGHarem（sgharem.site）、新加坡寂寞男人SGLonelyGuy（sglonelyguy.me）、新加坡美丽城堡SGBeautyCastle（sgbeautycastle.live）、Locanto.space、KK宝贝网（kkbaby.site）、幸福缘（xfy1.net）、幸福缘国际站（xfy8.com）、新加坡爽吧Shiok8（shiok26.site）、Shiok8国际版（shiok8.xyz）以及新加坡是您网（isyou.net）等行业知名平台建立了紧密的合作伙伴关系。
            </p>
            <p data-id="element-104">
              这一强大的平台联盟覆盖了新加坡伴游服务市场的各个细分领域：从高端VIP定制服务到大众化的伴游信息查询，从专业的伴游档案展示到活跃的用户社区交流，从华人专属服务到国际化多语言支持。芽笼777与各友站的深度合作，为客户构建了一个完整、可靠、高效的新加坡伴游服务生态系统。Geylang777.info提供最新行业资讯，Geylang666.me覆盖芽笼本地娱乐，TTVIP（ttvip-62.site/ttvip.life）专注高端VIP服务与生活方式，SGHarem和SGBeautyCastle提供丰富的伴游档案，SGLonelyGuy社区分享真实体验，Locanto.space聚合本地分类信息，KKBaby吸引年轻时尚群体，幸福缘（xfy1.net/xfy8.com）服务全球华人，Shiok8（shiok26.site/shiok8.xyz）带来本地与国际娱乐指南，isyou.net实现智能匹配推荐。
            </p>
            <p data-id="element-105">
              无论您是通过芽笼777的Telegram频道（t.me/gl777net）获取最新资讯，还是通过我们的官方网站（www.geylang777-5.site）浏览伴游档案，亦或是通过我们的合作伙伴平台了解更多选择，芽笼777始终致力于为您提供最安全、最优质、最满意的伴游服务体验。选择芽笼777，选择新加坡伴游服务的品质保证。
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}